import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { getLeadByID, dealLeadPost } from '../../redux/reduxActions/leadActions';
import { showToastError } from '../utils';

const DealLead = (props) => {
  const { selectedLead: { id, redmine_link } } = props;
  const [redmineLink, setRedmineLink] = useState('');
  const [comment, setComment] = useState();
  const [animationDone, setAnimationDone] = useState(false);
  useEffect(() => {
    props.getLeadByID(props.match.params.id);
  }, []);
  useEffect(() => {
	  if (redmine_link) {
      setRedmineLink(redmine_link);
	  }
  }, [props])
  function dealLeadAplly() {
    if (!redmineLink) {
      showToastError('redmineLink field is empty!!!');
    } else {
      setAnimationDone(!animationDone);
      props.dealLeadPost(id, { comment, redmine_link: redmineLink }).then(() => {
          props.history.push(window.history.back());
      }).catch((error) => {
          setAnimationDone(false);
        showToastError('Error 424 from server ! Redmine_link field must have only URL link')
        console.log(error);
      });
    }
  }
  return (
    <div>
      {animationDone ? <div className="wrap"><div className="wrapLoader" /></div> : null}
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
              Deal.Lead Action
            </h3>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                width: '200px',
              }}
            >
              <Button
                onClick={() => window.history.back()}
                size="sm"
                id="apply-filter"
              >
                Cancel
              </Button>
              <Button
                onClick={() => { dealLeadAplly(); }}
                size="sm"
                id="apply-filter"
              >
                Apply
              </Button>
            </div>
          </div>
          <div className="lead__container__inner" style={{ marginLeft: 30, marginTop: 20, marginBottom: 16 }}>
            <div>
              <p className="lead__title">
                Redmine Link
                <span style={{ color: 'red' }}>*</span>
              </p>
            </div>
            <TextareaAutosize
              onChange={(e) => setRedmineLink(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ width: '80%', padding: 10 }}
              placeholder="..."
              defaultValue={redmine_link}
            />
          </div>
          <TextareaAutosize
            onChange={({ target: { value } }) => { setComment(value); }}
            className="lead_input__first-message"
            rows={3}
            placeholder="..."
          />
        </div>
      </div>
    </div>
  );
};
export default connect((state) => ({
  responsible: state.leadReducer.responsible,
  selectedLead: state.leadReducer.selectedLead,
}), { getLeadByID, dealLeadPost })(DealLead);
